/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import { appViewState } from "..";
import { TeamBasicInfoEntity } from "../../../sh-models";

/**
 * Sets the selected teams in the cross location select teams modal
 * @param selectedTeams The selected teams
 */
export default mutatorAction(
    "SET_CROSS_LOCATION_SELECT_TEAMS_SELECTED_TEAMS",
    function setCrossLocationSelectTeamsSelectedTeams(selectedTeams: TeamBasicInfoEntity[]) {
        appViewState().crossLocationSelectTeamsModalViewState.selectedTeams = selectedTeams;
    }
);
